import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class InputGroup extends Component
{
    constructor(props) {
        super(props);

        this.state = {

        };
    }
    
    componentDidMount()
    {
    }
    
    render()
    {
        return (
                <div>
                    {
                        this.props.label &&
                        <label htmlFor={this.props.name}>{this.props.label}</label>
                    }
                    
                    <div className="input-group">
                        {
                            this.props.prepend &&
                            <div className="input-group-prepend">
                                <span className={this.props.prependClassName ? this.props.prependClassName : "input-group-text"}>{this.props.prepend}</span>
                            </div>
                        }
                        
                        <input 
                            name={this.props.name} 
                            defaultValue={this.props.defaultValue} 
                            type="text" 
                            className={this.props.className ? this.props.className : "form-control"}
                            placeholder={this.props.placeholder} 
                        />
                        
                        {
                            this.props.append &&
                            <div className="input-group-append">
                                <span className="input-group-text">{this.props.append}</span>
                            </div>
                        }
                    </div>
                </div>
                );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Core/InputGroup.js